import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";

const API = process.env.REACT_APP_BACKEND_URL;

export default function WhatsAppFamigliaDialog({ open, onOpenChange, lead, headers }) {
  const [to, setTo] = useState("");
  const [strutture, setStrutture] = useState([]);
  const [strutturaId, setStrutturaId] = useState("__none__");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTo(lead?.phone || lead?.mobile || "");
    setStrutturaId("__none__");
    fetch(`${API}/api/admin/strutture?attivo=true&limit=3000`, { headers })
      .then((r) => (r.ok ? r.json() : {}))
      .then((json) => setStrutture(json.data || json.strutture || []))
      .catch(() => setStrutture([]));
  }, [open, lead, headers]);

  const send = async () => {
    if (!lead?.id || !to.trim()) return toast.error("Indica il numero WhatsApp della famiglia.");
    setSending(true);
    try {
      const res = await fetch(`${API}/api/admin/leads/${lead.id}/whatsapp/famiglia`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          to: to.trim(),
          struttura_id: strutturaId === "__none__" ? null : strutturaId,
        }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.detail || "Invio WhatsApp non riuscito");
      toast.success("Messaggio WhatsApp inviato");
      onOpenChange(false);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>Invia WhatsApp alla famiglia</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-slate-600">Viene usato il template Meta approvato. Puoi allegare facoltativamente la scheda PDF di una struttura.</p>
          <div><Label>Numero WhatsApp *</Label><Input value={to} onChange={(event) => setTo(event.target.value)} placeholder="+39…" /></div>
          <div>
            <Label>Scheda struttura da allegare</Label>
            <Select value={strutturaId} onValueChange={setStrutturaId}>
              <SelectTrigger><SelectValue placeholder="Nessun allegato" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__none__">Nessun allegato</SelectItem>
                {strutture.map((s) => <SelectItem key={s.id} value={String(s.id)}>{s.name || s.nome || s.ragioneSociale || "Struttura"}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button><Button onClick={send} disabled={sending}>{sending ? "Invio…" : "Invia WhatsApp"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
